import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import {
  ILightGalleryItemProps,
  ILightGalleryProps,
} from '@ucheba/ui/components/LightGallery/types'

const Photos = styled.div<ILightGalleryProps>`
  display: flex;
  align-items: center;
  overflow-x: auto;
  -webkit-overflow-scrolling: auto;
`

const PhotosItem = styled.div<ILightGalleryItemProps>`
  margin-right: ${sv.spacing.xxsmall};

  img {
    border-radius: ${sv.radius.medium};
  }
`

const Block = styled.div<{ isDivider: boolean }>`
  padding-top: ${sv.spacing.xlarge};
  padding-bottom: ${sv.spacing.xlarge};

  border-top: 1px solid ${({ isDivider }) => (isDivider ? sv.color.gray9 : 'none')};
`
const Raiting = styled.div`
  display: flex;
  column-gap: 4px;

  svg {
    width: 18px;
    height: 18px;
    margin: 2px 0 4px 0;

    color: ${sv.color.orange};
  }
`

export default { Block, Photos, PhotosItem, Raiting }
